import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AssignTypeModal from "../../modals/AssignTypeModal";
import SystemMessageModal from "../../modals/SystemMessageModal";
import SystemRejectModal from "../../modals/SystemRejectModal";
import { useSelector } from "react-redux";
import { Get } from "../../config/api/get";
import { CARS, UPLOADS_URL } from "../../config/constants/api";
import { Put } from "../../config/api/put";
import swal from "sweetalert";

const ExistingCarApproval = () => {
  const [rejectionReason, setRejectionReason] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  const [carDetails, setCarDetails] = useState(null);
  const token = useSelector((state) => state.user.userToken);
  const [loading, setLoading] = useState(true);
  const [allImages, setAllImages] = useState(null);
  const [systemMessageModal1, setSystemMessageModal1] = useState(false);
  const [systemMessageModal2, setSystemMessageModal2] = useState(false);
  const [systemRejectModal, setSystemRejectModal] = useState(false);
  const [assignTypeModal, setAssignTypeModal] = useState(false);
  const [newServiceType, setServiceType] = useState(null);
  const location = useLocation();
  const showButtons = false || location?.state?.showButtons;
  const getUserDetails = () => {
    setLoading(true);
    Get(`${CARS.getCar}${id}`, token)
      .then((response) => {
        setCarDetails(response?.data);
        setAllImages([response?.data?.image, ...response?.data?.gallery]);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error fetching user details", err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getUserDetails();
    //eslint-disable-next-line
  }, []);
  const handleSubmit = (status) => {
    let data = {};
    if (status === "REJECTED") {
      data = {
        status,
        rejectionReason,
      };
    } else {
      data = {
        status,
        serviceType: newServiceType ?? newServiceType,
      };
    }
    Put(`${CARS.toggleStatus}${id}`, token, data)
      .then((response) => {
        if (response.status) {
          swal("System Alert!", response?.message, "success");
          navigate("/carRequest/existing");
        }
      })
      .catch((err) => {
        let message = err?.response?.data?.message;
        console.log(":::;", err);
        if (message) swal("Oops!", message, "error");
      });
  };
  return (
    <div>
      <Row justify="center">
        {!loading && <Col md={23} xs={22}>
          <div
            className="bg-white rounded-lg sm:py-16 py-8 my-12"
            style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
          >
            <div className="flex justify-between items-center mx-4 lg:mx-8 mb-4">
              <div className="flex justify-center items-center">
                <IoIosArrowRoundBack
                  onClick={() => navigate(-1)}
                  className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
                />
                <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                  Car Details
                </h3>
              </div>
              <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold">
                Service Type: {carDetails?.serviceType} Luxury
              </h5>
            </div>
            <Row justify="center">
              <Col xs={22} sm={18} md={18} lg={14} xxl={12}>
                <div className="bg-[#EBEBEB] rounded-lg items-center justify-center sm:py-12 py-6 ">
                  <Row justify="center">
                    <Col xs={18}>
                      <div className="flex justify-center items-center my-4 w-full">
                        <div className="flex flex-col items-start w-full">
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Car Brand
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {carDetails?.brand}
                          </p>
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Car Model
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {carDetails?.model}
                          </p>
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Car Type
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {carDetails?.serviceType}
                          </p>
                        </div>
                        <div className="flex flex-col items-start w-full">
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Car Name
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {carDetails?.name}
                          </p>
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Car Number
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {carDetails?.carNumber}
                          </p>
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Passenger Capacity
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {carDetails?.passengerCapacity}
                          </p>
                        </div>
                      </div>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1 w-full">
                        Car Images
                      </h5>
                      {Array.isArray(allImages) && (
                        <Row justify="start">
                          {allImages.map((image, index) => {
                            return (
                              <Col key={index} lg={4} md={6} xs={8}>
                                <img
                                  // style={{
                                  //   height: "100px",
                                  //   width: "100px",
                                  //   objectFit: "cover",
                                  //   objectPosition: "center",
                                  // }}
                                  src={UPLOADS_URL + image}
                                  alt="car"
                                />
                              </Col>
                            );
                          })}
                          {/* <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col>
                        <Col lg={4} md={6} xs={8}>
                          <img src={ImageUrl("car.png")} alt="car" />
                        </Col> */}
                        </Row>
                      )}
                    </Col>
                  </Row>

                  {showButtons && (
                    <div className="flex flex-col items-center justify-center mt-8">
                      <button
                        className="uppercase bg-button py-3 px-6 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 font-euclid"
                        onClick={() => setAssignTypeModal(true)}
                      >
                        APPROVED CAR & ASSIGN SERVICE
                      </button>
                      <button
                        className="uppercase bg-[#D90811] py-3 px-6 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 mt-4 font-euclid"
                        onClick={() => setSystemRejectModal(true)}
                      >
                        REJECT THIS CAR
                      </button>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </Col>}
      </Row>
      {systemMessageModal2 && (
        <SystemMessageModal
          systemMessageModal={systemMessageModal2}
          setSystemMessageModal={setSystemMessageModal2}
          message={"Driver Account request has been rejected successfully"}
          path={-1}
        />
      )}
      {systemMessageModal1 && (
        <SystemMessageModal
          systemMessageModal={systemMessageModal1}
          setSystemMessageModal={setSystemMessageModal1}
          message={"Car changes request approved successfully"}
          path={-1}
        />
      )}
      {systemRejectModal && (
        <SystemRejectModal
          systemRejectModal={systemRejectModal}
          setSystemRejectModal={setSystemRejectModal}
          setSystemMessageModal={setSystemMessageModal2}
          banUser={handleSubmit}
          setRejectionReason={setRejectionReason}
          rejectionReason={rejectionReason}
        />
      )}
      {assignTypeModal && (
        <AssignTypeModal
          assignTypeModal={assignTypeModal}
          setAssignTypeModal={setAssignTypeModal}
          setSystemMessageModal={setSystemMessageModal1}
          setServiceType={setServiceType}
          handleSubmit={handleSubmit}
        />
      )}
    </div>
  );
};

export default ExistingCarApproval;
